import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';

import { ExecutingUnit } from '../entities/executingUnit';
import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum'; 
import { ResponsePageable } from '../../shared/_utils/services/responsePageable';
import { ArrayEntry } from '../model/arrray-entry';
import { Observable } from 'rxjs/Observable';
import { tap, catchError, switchAll } from 'rxjs/operators';


interface ExtraSearchFields {
  arrayEntry? :ArrayEntry;
}

@Injectable()
export class ArrayEntryService extends BaseCrudService<ArrayEntry> {

  public uri = '/api/arrayEntry/';

  constructor(injector: Injector) {
    super(injector);
   //console.log('Instance arrayEntryService');
  }

  buildSentence(entity?: ArrayEntry, event?: LazyLoadEvent, extraSearchFields?: ExtraSearchFields ): HttpParams { 
    if (entity || extraSearchFields) {
      let query = '';
      /*
      query = query.concat(
        entity && entity.userName ?
          `userName${QueryOperator.Equal}${entity.userName}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity && entity.firstLastName ?
          `firstLastName${QueryOperator.Contain}${entity.firstLastName}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity && entity.secondLastName ?
          `secondLastName${QueryOperator.Contain}${entity.secondLastName}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity && entity.name ?
          `name${QueryOperator.Contain}${entity.name}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity && entity.executingUnit ?
          `executingUnit.id${QueryOperator.Equal}${entity.executingUnit.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      /*let query = entity.executingUnit ? 'executingUnit'
        + QueryOperator.Contain + entity.executingUnit
        + QueryOperator.Split : QueryOperator.Empty;  
      if (entity.executingUnit && entity.executingUnit.id) {
        query = query.concat(
          `executingUnit.id${QueryOperator.Equal}${entity.executingUnit.id}${QueryOperator.Split}`
        );
      }  
      */
    //console.log(query);
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }  
    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }
  
  insert(ae :ArrayEntry): Observable<any> {
    const url = this.rutaServidor + this.uri;
    this.spinnerService.showAll(); 
    return this.httpClient.post<ArrayEntry>(url, ae); 
}  

  update( id : number ,ae :ArrayEntry): Observable<any> {
      const url = this.rutaServidor + this.uri+id;
      this.spinnerService.showAll();   
      return this.httpClient.put<ArrayEntry>(url, ae)
    }  


    delete(id : number): Observable<any> { 
      const url = this.rutaServidor + this.uri +id; 
      return this.httpClient.delete(url); 
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/array-entry.service.ts